import React from "react";
import { Field, Form } from "react-final-form";
import { Box, TextField, Paper } from "@material-ui/core";
import createDecorator from "final-form-focus";
import { ButtonLoader, Loader } from "../../../components";
import { useTranslation } from "react-i18next";
import { useYupValidation } from "../../../hooks";
import { string, object } from "yup";

const focusOnErrors = createDecorator();

const validationSchema = object({
  code: string()
    .min(6)
    .max(6)
    .required()
    .trim()
    .label("Code")
});

const Login2FAForm = ({ onSubmit, formSubmitting, children }) => {
  const { t } = useTranslation();
  const { validate } = useYupValidation();

  const validateForm = async data => {
    const errors = await validate(validationSchema)(data);

    if (errors) return errors;

    onSubmit(data);
  };

  if (formSubmitting) return <Loader />;

  return (
    <Box mx={2}>
      <Paper>
        <Box p={2} pt={3}>
          {children}
          <Form
            onSubmit={validateForm}
            decorators={[focusOnErrors]}
            render={({ handleSubmit, submitErrors: errors = {} }) => (
              <form onSubmit={handleSubmit}>
                <Field
                  name="code"
                  render={({ input }) => (
                    <TextField
                      {...input}
                      data-cy="input-login-2fa-code"
                      autoFocus
                      margin="none"
                      variant="outlined"
                      label={t("auth.two_factor.form.code.label")}
                      fullWidth
                      autoComplete="one-time-code"
                      type="tel"
                      error={!!errors.code}
                      helperText={errors.code}
                    />
                  )}
                />
                <Box mt={2}>
                  <ButtonLoader
                    data-cy="button-login-2fa-submit"
                    type="submit"
                    color="primary"
                    variant="contained"
                    fullWidth
                    loading={formSubmitting}
                    size="large"
                  >
                    {t("auth.two_factor.button")}
                  </ButtonLoader>
                </Box>
              </form>
            )}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export { Login2FAForm };
